import PDFList from "components/pdfList";
import SEO from "components/SEO";
import { fetchPost } from "functions";
import useTranslation from "translations/hooks/useTranslation";

const JoinOEA = ({ pageData, lang }) => {
  const { t } = useTranslation();

  return (
    <>
      <SEO title={t("joinOea")} description={t("joinOea")} />
      <PDFList
        lang={lang}
        pageData={pageData}
        title={"joinOea"}
        breadcrumb={"membershipTerms"}
      />
    </>
  );
};

export default JoinOEA;

export async function getServerSideProps(context) {
  let { lang } = context?.query;

  let pageData = await fetchPost({
    apiName: `oea-membership-terms/get`,
    reqBody: { lang },
  });

  return {
    props: {
      lang,
      pageData: pageData?.response,
    },
  };
}
